import { OrderSideEnum } from './../../enum/orders/side.enum';

export class CustodyClientOrder {


    get side(): OrderSideEnum{
        return this._side? this._side : this.total > 0 ? OrderSideEnum.Compra : OrderSideEnum.Venda;
    }
    set side(side: OrderSideEnum){
        this._side = side;
    }
    
    get isDayTrade(){
        return this.isDaytrade;
    }
    private _side: OrderSideEnum;

    constructor ( 
        public symbol: string,
        public total: number,
        public id: string,
        public isDaytrade: boolean = false,
        public averagePrice: number,
        public ordersAmountInvested: number,
    ){
    } 
}